import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import { Field, FieldArray, reduxForm, SubmissionError } from "redux-form";
import * as cc from "currency-codes";
import LoadingProgress from "../components/LoadingProgress";

import Box from "../components/Box";

import { fetchContract, updateContract } from "../actions/contracts";
import { fetchMachines, resetMachines } from "../actions/machines";
import { fetchCustomers } from "../actions/customers";
import { fetchCalendarsName } from "../actions/calendars";

import {
  renderInputField,
  renderSelectField,
  renderTextAreaField,
} from "../utils/forms";
import QRZonesList from "../components/QRZonesList";
import ToggleSwitch from "../components/ToggleSwitch";
import "../styles/MachinesAdminView.css";

class ContractEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      fCustomers: null,
      fMachines: null,
      customerSelected: "",
      showDynamicField: false,
      hybridMode: false,
      requireIdNumber: false,
      activeTab: 'asignacion',
    };

    this.setTab = this.setTab.bind(this);

    this.load = this.load.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const {
      fetchContract,
      fetchMachines,
      fetchCustomers,
      fetchCalendarsName,
      match,
    } = this.props;

    fetchContract(match.params.id);
    fetchCalendarsName();
    fetchMachines();
    fetchCustomers();

    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(props) {
    const { contract, machines, customers } = props;

    if (!this.state.loaded && contract && machines && customers) {
      this.setState({
        loaded: true,
        customerSelected: contract.Customer._id,
        hybridMode: contract.HybridMode || false,
        requireIdNumber: contract.RequireIdNumber || false,
        fMachines: machines.filter(
          (machine) =>
            machine.Customer === undefined ||
            machine._id === contract.Machine._id,
        ),
      });
    }
  }

  submit(props) {
    const { updateContract, contract } = this.props;

    // Convert hours + minutes into total minutes
    const hours = parseInt(props.hours || 0, 10);
    const minutes = parseInt(props.minutes || 0, 10);
    props.TimeSlots = hours * 60 + minutes;

    // Optional: clean up the original inputs if not needed by backend
    delete props.hours;
    delete props.minutes;

    props.Executor = this.props.fullname;

    return updateContract(contract._id, props).then((response) => {
      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields,
        });
      }

      return response;
    });
  }

  renderItems(props) {
    const { fields } = props;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Artículo</th>
                <th scope="col">Precio (PVP)</th>
                <th scope="col">Comisión Cliente (%)</th>
                <th scope="col">Stock</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((member, index) => (
                <tr key={index}>
                  <td>
                    <Field
                      name={`${member}.item`}
                      component={renderSelectField}
                    >
                      <option value="" key="default">
                        Selecciona un artículo...
                      </option>
                      <option value="LOCKERBNS" key="LOCKERBNS">
                        Standard
                      </option>
                      <option value="LOCKERCNS" key="LOCKERCNS">
                        Standard Carga
                      </option>
                      <option value="LOCKERBWS" key="LOCKERBWS">
                        Standard XL
                      </option>
                      <option value="LOCKERCWS" key="LOCKERCWS">
                        Standard Carga XL
                      </option>
                      <option value="LOCKERBNM" key="LOCKERBNM">
                        Medium
                      </option>
                      <option value="LOCKERCNM" key="LOCKERCNM">
                        Medium Carga
                      </option>
                      <option value="LOCKERBWM" key="LOCKERBWM">
                        Medium XL
                      </option>
                      <option value="LOCKERCWM" key="LOCKERCWM">
                        Medium Carga XL
                      </option>
                      <option value="LOCKERBNL" key="LOCKERBNL">
                        Large
                      </option>
                      <option value="LOCKERCNL" key="LOCKERCNL">
                        Large Carga
                      </option>
                      <option value="LOCKERBWL" key="LOCKERBWL">
                        Large XL
                      </option>
                      <option value="LOCKERCWL" key="LOCKERCWL">
                        Large Carga XL
                      </option>
                      <option value="LOCKERBNXL" key="LOCKERBNXL">
                        Large 4
                      </option>
                      <option value="LOCKERCNXL" key="LOCKERCNXL">
                        Large 4 Carga
                      </option>
                      <option value="LOCKERBWXL" key="LOCKERBWXL">
                        Large 4 XL
                      </option>
                      <option value="LOCKERCWXL" key="LOCKERCWXL">
                        Large 4 Carga XL
                      </option>
                      <option value="LOCKERBN2XL" key="LOCKERBN2XL">
                        Large 5
                      </option>
                      <option value="LOCKERCN2XL" key="LOCKERCN2XL">
                        Large 5 Carga
                      </option>
                      <option value="LOCKERBW2XL" key="LOCKERBW2XL">
                        Large 5 XL
                      </option>
                      <option value="LOCKERCW2XL" key="LOCKERCW2XL">
                        Large 5 Carga XL
                      </option>
                      <option value="LOCKERBN3XL" key="LOCKERBN3XL">
                        Ski
                      </option>
                      <option value="LOCKERCN3XL" key="LOCKERCN3XL">
                        Ski Carga
                      </option>
                      <option value="LOCKERBW3XL" key="LOCKERBW3XL">
                        Ski XL
                      </option>
                      <option value="LOCKERCW3XL" key="LOCKERCW3XL">
                        Ski Carga XL
                      </option>
                      {/* Voucher/Coupon Locker Types */}
                      <option value="LOCKERXNS" key="LOCKERXNS">
                        Voucher Standard (X)
                      </option>
                      <option value="LOCKERXWS" key="LOCKERXWS">
                        Voucher Standard XL (X)
                      </option>
                      <option value="LOCKERXNM" key="LOCKERXNM">
                        Voucher Medium (X)
                      </option>
                      <option value="LOCKERXWM" key="LOCKERXWM">
                        Voucher Medium XL (X)
                      </option>
                      <option value="LOCKERXNL" key="LOCKERNL">
                        Voucher Large (X)
                      </option>
                      <option value="LOCKERXWL" key="LOCKERWL">
                        Voucher Large XL (X)
                      </option>
                      <option value="LOCKERXNXL" key="LOCKERNXL">
                        Voucher Large 4 (X)
                      </option>
                      <option value="LOCKERXWXL" key="LOCKERWXL">
                        Voucher Large 4 XL (X)
                      </option>
                      <option value="LOCKERXN2XL" key="LOCKERXN2XL">
                        Voucher Large 5 (X)
                      </option>
                      <option value="LOCKERXW2XL" key="LOCKERXW2XL">
                        Voucher Large 5 XL (X)
                      </option>
                      <option value="LOCKERXN3XL" key="LOCKERXN3XL">
                        Voucher Ski (X)
                      </option>
                      <option value="LOCKERXW3XL" key="LOCKERXW3XL">
                        Voucher Ski XL (X)
                      </option>
                      <option value="TUMBONAS" key="TUMBONAS">
                        Tumbonas
                      </option>
                      <option value="FLOTADORES" key="FLOTADORES">
                        Flotadores
                      </option>
                      <option value="FLOTADORESHALFDAY" key="FLOTADORESHALFDAY">
                        Flotadores Medio Día
                      </option>
                      <option value="FASTPASS" key="FASTPASS">
                        Fastpass
                      </option>
                    </Field>
                  </td>
                  <td>
                    <Field
                      name={`${member}.price`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${member}.comission`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${member}.stock`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="btn bg-vw-light text-white"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    );
  }

  setTab(tab) {
    this.setState({ activeTab: tab });
  }

  handleShowDynamicField() {
    this.setState({
      showDynamicField: true,
    });
  }

  render() {
    const { loaded, fMachines, activeTab } = this.state;
    const {
      contract,
      customers,
      calendars,
      error,
      pristine,
      handleSubmit,
      submitting,
    } = this.props;

    if (!loaded || !customers || !fMachines || !calendars) {
      return <LoadingProgress />;
    }

    return (
      <div className="machines-admin-view">
        <form onSubmit={handleSubmit(this.submit)}>
          <div className="mach-admin-header">
            <div className="header-content">
              <div className="header-text">
                <h1>
                  <i className="fas fa-edit mr-2"></i>
                  Editar Contrato
                  <span className="ml-2 text-vw-dark">{contract.Machine.Serial}</span>
                </h1>
              </div>
              <div className="header-actions">
                <Link to={`/contracts/${contract._id}`} className="mach-admin-btn secondary">
                  <i className="fas fa-arrow-left"></i>
                  <span className="d-none d-sm-inline">Volver</span>
                </Link>
                <button
                  className="mach-admin-btn success"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  <i className="fas fa-save"></i>
                  <span className="d-none d-sm-inline">{submitting ? 'Guardando...' : 'Guardar'}</span>
                </button>
              </div>
            </div>
          </div>

          <div className="od-page-nav">
            {[
              { id: 'asignacion',     icon: 'fa-arrows-alt-h',  label: 'Asignación' },
              { id: 'funcionamiento', icon: 'fa-cogs',           label: 'Funcionamiento' },
              { id: 'ticket',         icon: 'fa-receipt',        label: 'Ticket' },
              { id: 'articulos',      icon: 'fa-shopping-cart',  label: 'Artículos' },
            ].map(t => (
              <button
                key={t.id}
                type="button"
                className={`od-page-tab${activeTab === t.id ? ' active' : ''}`}
                onClick={() => this.setTab(t.id)}
              >
                <i className={`fas ${t.icon}`}></i>
                <span>{t.label}</span>
              </button>
            ))}
          </div>

          {/* === TAB: ASIGNACIÓN === */}
          {activeTab === 'asignacion' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-3">
                  <Box title="Cliente y Máquina" icon="arrows-alt-h">
                    <Field
                      name="Customer"
                      component={renderSelectField}
                      label="Cliente"
                      onChange={(e) => { this.setState({ customerSelected: e.target.value }); }}
                    >
                      {customers && customers
                        .filter(c => c.Type === "GENERAL" || c.Type === "LICENCIA_BASICA" || c.Type === "LICENCIA_PRO")
                        .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                        .map(c => <option value={c._id} key={c._id}>{c.Fullname}</option>)}
                    </Field>
                    <Field name="Machine" component={renderSelectField} label="Máquina">
                      {fMachines.map(m => <option value={m._id} key={m._id}>{m.Serial}</option>)}
                    </Field>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-3">
                  <Box title="Zonas QR" icon="map-marker-alt">
                    <Field name="Location" component={renderInputField} type="text" label="Localización (Lat, Lon)" />
                    <QRZonesList customers={customers} customerSelected={this.state.customerSelected} />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-3">
                  <Box title="Vigencia" icon="calendar-check">
                    <Field name="StartDate" component={renderInputField} type="date" label="Fecha inicio" />
                    <Field name="EndDate" component={renderInputField} type="date" label="Fecha fin" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-3">
                  <Box title="Divisa" icon="money-bill">
                    <Field name="Currency" component={renderSelectField} value="EUR" label="Moneda">
                      {cc.codes().map(code => {
                        const name = cc.code(code).currency;
                        return <option value={code} key={code}>{`${code} - ${name}`}</option>;
                      })}
                    </Field>
                    <Field name="ConversionRate" component={renderInputField} type="text" label="Tasa de conversión" />
                  </Box>
                </div>
              </div>
            </div>
          )}

          {/* === TAB: FUNCIONAMIENTO === */}
          {activeTab === 'funcionamiento' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-4">
                  <Box title="Modo de Trabajo" icon="cogs">
                    <Field name="WorkingMode" component={renderSelectField} label="Working Mode">
                      <option value="">Selecciona un modo...</option>
                      <option value="0">MTO DIARIO</option>
                      <option value="1">MTO DIARIO + SERVICIOS</option>
                      <option value="2">MTO DIARIO TIEMPO SIN PIN</option>
                      <option value="3">MTO DIARIO TIEMPO CON PIN</option>
                      <option value="4">OTO DIARIO SIN PIN</option>
                      <option value="5">OTO DIARIO CON PIN</option>
                      <option value="6">RESERVA ANTICIPADA</option>
                      <option value="7">TAQUILLAS AQUARIAZ</option>
                      <option value="8">PAQUETERÍA</option>
                    </Field>
                    <Field name="DoorAccess" component={renderInputField} type="text" label="Acceso a local" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-4">
                  <Box title="Tiempo" icon="clock">
                    <div className="form-group">
                      <label>Rango de tiempo</label>
                      <div className="d-flex" style={{ gap: '10px', alignItems: 'center' }}>
                        <Field name="hours" component="input" type="number" min="0"
                          placeholder="Horas" className="form-control w-25 text-center" />
                        <span>:</span>
                        <Field name="minutes" component="input" type="number" min="0" max="59"
                          placeholder="Minutos" className="form-control w-25 text-center" />
                      </div>
                    </div>
                    <Field name="TimeCourtesy" component={renderSelectField} label="Tiempo de cortesía">
                      <option value="">Selecciona un tiempo...</option>
                      <option value="0">0 minutos</option>
                      <option value="5">5 minutos</option>
                      <option value="10">10 minutos</option>
                      <option value="15">15 minutos</option>
                      <option value="30">30 minutos</option>
                    </Field>
                  </Box>
                </div>
                <div className="col-xs-12 col-md-4">
                  <Box title="Opciones" icon="toggle-on">
                    <div className="row" style={{ alignItems: 'center' }}>
                      <div className="col-md-6">
                        <Field
                          name="HybridMode"
                          component={ToggleSwitch}
                          label="Modo híbrido"
                          onChange={(e, newValue) => this.setState({ hybridMode: newValue })}
                        />
                      </div>
                      <div className="col-md-6">
                        {this.state.hybridMode ? (
                          <div className="alert alert-success" style={{ fontSize: '12px', margin: 0 }}>
                            <i className="fas fa-check-circle mr-1"></i>
                            <strong>Activo:</strong> También permitirá reserva anticipada simultáneamente.
                          </div>
                        ) : (
                          <div className="alert alert-warning" style={{ fontSize: '12px', margin: 0 }}>
                            <i className="fas fa-info-circle mr-1"></i>
                            <strong>Inactivo:</strong> Funcionará únicamente con el modo de trabajo seleccionado.
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row" style={{ alignItems: 'center', marginTop: '10px' }}>
                      <div className="col-md-6">
                        <Field
                          name="RequireIdNumber"
                          component={ToggleSwitch}
                          label="Solicitar Documento de Identidad"
                          onChange={(e, newValue) => this.setState({ requireIdNumber: newValue })}
                        />
                      </div>
                      <div className="col-md-6">
                        {this.state.requireIdNumber ? (
                          <div className="alert alert-success" style={{ fontSize: '12px', margin: 0 }}>
                            <i className="fas fa-check-circle mr-1"></i>
                            <strong>Activo:</strong> Se pedirá el DNI / NIE / Pasaporte al cliente.
                          </div>
                        ) : (
                          <div className="alert alert-warning" style={{ fontSize: '12px', margin: 0 }}>
                            <i className="fas fa-info-circle mr-1"></i>
                            <strong>Inactivo:</strong> No se requerirá identificación al cliente.
                          </div>
                        )}
                      </div>
                    </div>
                  </Box>
                </div>
              </div>
            </div>
          )}

          {/* === TAB: TICKET === */}
          {activeTab === 'ticket' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-4">
                  <Box title="Ticket" icon="receipt">
                    <Field name="TicketHeader" component={renderInputField} type="text" label="Cabecera" />
                    <Field name="TicketIVA" component={renderInputField} type="text" label="IVA (%)" />
                    <Field name="TicketFooter" component={renderInputField} type="text" label="Footer" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-4">
                  <Box title="Términos y Condiciones" icon="gavel">
                    <Field name="TermsLink" component={renderInputField} type="text" label="Términos" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-4">
                  <Box title="Mensaje en Start" icon="comment-dots">
                    <Field name="StartMessage" component={renderInputField} type="text" label="Mensaje" />
                  </Box>
                </div>
              </div>
            </div>
          )}

          {/* === TAB: ARTÍCULOS === */}
          {activeTab === 'articulos' && (
            <div style={{ paddingTop: '20px' }}>
              <div className="row">
                <div className="col-xs-12 col-md-4">
                  <Box title="Calendario de precios" icon="calendar-alt">
                    <Field name="Calendar" component={renderSelectField} label="Calendario de precios">
                      <option value="">Selecciona un calendario...</option>
                      {calendars && calendars
                        .sort((a, b) => a.Name.localeCompare(b.Name))
                        .map(cal => <option value={cal._id} key={cal._id}>{cal.Name}</option>)}
                    </Field>
                    <Field name="LocalCalendar" component={ToggleSwitch} label="Calendario local (precios dinámicos)" />
                  </Box>
                </div>
                <div className="col-xs-12 col-md-8">
                  <Box title="Artículos" icon="shopping-cart">
                    <FieldArray name="Items" component={this.renderItems} />
                  </Box>
                </div>
              </div>
            </div>
          )}

          {error && <div className="alert alert-danger mt-3">{error}</div>}
        </form>
      </div>
    );
  }
}

ContractEditForm = reduxForm({
  form: "ContractEditForm",
  onSubmitSuccess: (result, dispatch, props) => {
    props.resetMachines();
    props.push(`/contracts/${result.response._id}`);
  },
  enableReinitialize: true,
})(ContractEditForm);

const mapStateToProps = (state) => {
  let StartDate = null;
  let EndDate = null;
  let Customer = null;
  let Machine = null;

  let hours = 0;
  let minutes = 0;

  if (state.contracts.contract && state.contracts.contract.TimeSlots != null) {
    hours = Math.floor(state.contracts.contract.TimeSlots / 60);
    minutes = state.contracts.contract.TimeSlots % 60;
  }

  if (state.contracts.contract) {
    StartDate = state.contracts.contract.StartDate;
    EndDate = state.contracts.contract.EndDate;
    Customer = state.contracts.contract.Customer._id;
    Machine = state.contracts.contract.Machine._id;
  }

  return {
    contract: state.contracts.contract,
    machines: state.machines.machines,
    customers: state.customers.customers,
    calendars: state.calendars.calendars,
    fullname: state.auth.fullname,
    initialValues: {
      ...state.contracts.contract,
      StartDate: new Date(StartDate).toISOString().substring(0, 10),
      EndDate: new Date(EndDate).toISOString().substring(0, 10),
      Customer: Customer,
      Machine: Machine,
      Calendar: state.contracts.contract?.Calendar?._id || "",
      Zone: state.contracts.contract?.Zone || "",
      hours,
      minutes,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchContract: bindActionCreators(fetchContract, dispatch),
  fetchCalendarsName: bindActionCreators(fetchCalendarsName, dispatch),
  updateContract: bindActionCreators(updateContract, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  resetMachines: bindActionCreators(resetMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractEditForm);
